import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { RolepermissionService } from 'src/app/services/rolepermission.service';
import { Rolepermission } from 'src/app/model/rolepermission.model';
import { DateService } from 'src/app/services/date.service';
import { CommonService } from 'src/app/services/common.service';
import { RemovemodaluserroleComponent } from 'src/app/modal/remove-modal-user-role/remove-modal-user-role.component';
import { AssignmodaluserroleComponent } from 'src/app/modal/assign-modal-user-role/assign-modal-user-role.component';
@Component({
  standalone: false,
  selector: 'app-user-role-permission',
  templateUrl: './user-role-permission.component.html',
  styleUrls: ['./user-role-permission.component.scss']
})
export class UserRolePermissionComponent implements OnInit {

  private subscriptions = new Subscription();
  public rolepermission = new Rolepermission();

  page: any;
  totalPages = 1;
  indexPage = 1;
  totalRows: number = 0;
  searchText: string = '';
  parkId: any;
  showDropdown: boolean = false;

  mainUserList: any[] = [];
  newmainUserList: any[] = [];
  newmainUserListReported = [];
  newmainUserListHide = [];
  userDeepCopy: any;
  newMainUsers: any;
  userTempNew: any;
  masterSelectedUser: boolean;
  checkedUserList: any;
  checkedOnlyUserList: any;
  onlyUserIds = [];
  newmainUserRoleList = [];
  finalSubmissionArray = [];

  //pagination
  pageSize = 10;
  pageNo = 1;
  totalCount = 0;
  displayCount = 0;
  totalCountList: number = 0;
  newmainUserRoleListFiltred = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private rolepermissionService: RolepermissionService,
  ) {
    localStorage.setItem('expandNavFoodCourt', 'true');
    const routeLink = this.sideNavService.routingChunks({
      name: 'Food Court Management',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(routeLink);
  }

  ngOnInit(): void {
    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
    localStorage.removeItem('expandNavCreateview');

    // this.totalRows = 0;
    // this.pageNo = 0;
    // this.pageSize = 10;
    // this.page = 0;
    // this.indexPage = 1;

    this.getTheUserList();
    this.getTheUserRoleList();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavFoodCourt');
    this.subscriptions.unsubscribe();
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  openPopoverReceived(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  paginationCount(val: number) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  searchByText(event: any) {
    if (!event || event === '') {
      // Reset to original list
      this.newmainUserList = this.mainUserList;
      this.totalRows = this.newmainUserList?.length;
      this.totalCountList = this.mainUserList?.length || 0;
      return;
    }

    // Filter based on search text
    const searchLower = event.toLowerCase();
    this.newmainUserList = this.mainUserList.filter((item: { adminName: any }) => {
      if (!item || !item.adminName) return false;
      return item.adminName.toLowerCase().includes(searchLower);
    });
    this.totalRows = this.newmainUserList?.length;
    this.totalCountList = this.newmainUserList?.length || 0;
  }

  handlePageChange($event) {
    this.pageNo = $event;
    this.getTheUserList();
  }

  fetchPage(val) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  checkUncheckAll() {
    for (var i = 0; i < this.newmainUserListReported.length; i++) {
      this.newmainUserListReported[i].isSelected = this.masterSelectedUser;
    }
    this.getCheckedItemList();
    console.log(this.masterSelectedUser);
    if (this.masterSelectedUser === false) {
      this.showDropdown = false;
    }
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.showDropdown = false;
    this.masterSelectedUser = this.newmainUserListReported.every(function (item: any) {
      return item.isSelected === true;
    });
    console.log(this.masterSelectedUser);
    this.getCheckedItemList();
  }

  getCheckedItemList() {

    this.checkedUserList = [];
    this.checkedOnlyUserList = [];
    this.onlyUserIds = [];

    for (var i = 0; i < this.newmainUserListReported?.length; i++) {

      if (this.newmainUserListReported[i].isSelected) {
        this.checkedUserList.push(this.newmainUserListReported[i]);
        this.checkedOnlyUserList.push(this.newmainUserListReported[i]);
        this.showDropdown = true;
      }
    }

    for (var j = 0; j < this.checkedOnlyUserList?.length; j++) {
      this.onlyUserIds.push(this.checkedOnlyUserList[j].empId);
    }

    console.log(this.onlyUserIds);
    this.checkedUserList = JSON.stringify(this.checkedUserList);

  }

  getTheUserList() {

    let body = {
      pageNo: this.pageNo,
      size: this.pageSize,
      searchText: '',
      parkId: localStorage.getItem('parkId')
    };

    this.parkId = localStorage.getItem('parkId');

    this.rolepermissionService.getTheUserList(body).subscribe((res) => {
      if (res?.isValid === true) {
        this.mainUserList = res?.data.userList;
        // this.newmainSurveyList = res?.data.foodCourtVendorReviewList;
        this.newmainUserList = res?.data.userList;
        this.newmainUserListReported = res?.data.userList;
        console.log(this.newmainUserList);
        this.newMainUsers = res?.data.userList;
        this.userDeepCopy = JSON.parse(JSON.stringify(res.data.userList));
        this.userTempNew = res?.data.userList;
        this.totalRows = res?.data.userList.length;
        this.totalCountList = res?.data.totalCount;
        console.log(this.totalCountList);
      } else {
        this.mainUserList = [];
        this.newmainUserList = [];
        this.totalRows = 0;
      }
    });

    for (var i = 0; i < this.mainUserList?.length; i++) {
      this.mainUserList[i].isSelected = false;
    }

    console.log(this.mainUserList);
    this.getCheckedItemList();
  }

  getTheUserRoleList() {
    this.rolepermissionService.getUserRoleList().subscribe((res) => {
      if (res?.isValid === true) {
        this.newmainUserRoleList = res?.list;
      } else {
        this.newmainUserRoleList = [];
      }
    });

    this.newmainUserRoleList = this.newmainUserRoleList.map(permission => ({
      ...permission,
      isSelected: false
    }));

    console.log(this.newmainUserRoleList);
  }

  assignRoleToUserGroup(roleId) {

    this.finalSubmissionArray = [];
    this.finalSubmissionArray.push({
      "empId": this.onlyUserIds,
      "userRoleId": roleId,
      "createdBy": localStorage.getItem('claAdminId'),
      "parkId": localStorage.getItem('parkId'),
    });

    console.log(this.finalSubmissionArray);

    // this.rolepermissionService
    //   .addUserRoleMappping(this.finalSubmissionArray[0])
    //   .subscribe((res) => {
    //     window.location.reload();
    //     // this.router.navigate(['/role-permission/']);
    //   });

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };
    const modalRef = this.modalService.open(AssignmodaluserroleComponent, modalOptions);
    modalRef.componentInstance.finalSubmissionArray = this.finalSubmissionArray;
  }

  assignRoleToUser(employeeId, roleId) {

    this.finalSubmissionArray = [];
    this.finalSubmissionArray.push({
      "empId": [employeeId],
      "userRoleId": roleId,
      "createdBy": localStorage.getItem('claAdminId'),
      "parkId": localStorage.getItem('parkId')
    });

    console.log(this.finalSubmissionArray);

    // this.rolepermissionService
    //   .addUserRoleMappping(this.finalSubmissionArray[0])
    //   .subscribe((res) => {
    //     window.location.reload();
    //     // this.router.navigate(['/role-permission/']);
    //   });

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };
    const modalRef = this.modalService.open(AssignmodaluserroleComponent, modalOptions);
    modalRef.componentInstance.finalSubmissionArray = this.finalSubmissionArray;
  }

  removeRoleFromUser(roleMappingId) {
    // this.rolepermissionService
    //   .removeUserRolePermission(roleMappingId)
    //   .subscribe((res) => {
    //     window.location.reload();
    //     // this.router.navigate(['/role-permission/']);
    //   });

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };
    const modalRef = this.modalService.open(RemovemodaluserroleComponent, modalOptions);
    modalRef.componentInstance.roleMappingId = roleMappingId;
  }

  checkUserRoleFromMailList(userrolename) {
    console.log(userrolename);
    this.newmainUserRoleListFiltred = this.newmainUserRoleList.filter(role => role.userRoleName !== userrolename);
  }
}
